<template>
  <div v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Custo do Evento</h3>
      </div>
      <div>
        <div class="m-3 mb-5">
          <h5 class="mb-2">Franquia</h5>
          <div class="vx-row">
            <div class="vx-col flex gap-3 mb-2 items-baseline">
              <vs-button color="success" @click="calcularFipeMesEvento">
                Calcular FIPE Mês Evento
              </vs-button>
              <p>
                Data de referência:
                {{ dataReferenciaValorFipe }}
              </p>
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/4 w-1/2 mb-2 text-center">
              <span class="vs-input--label">Valor FIPE no Mês do Evento</span>
              <p class="money-style">
                {{ this.valorFipeDataEventoEmReal }}
              </p>
            </div>
            <div class="lg:w-1/4 w-1/2 mb-2 text-center hidden">
              <span class="vs-input--label">Valor Mínimo da Franquia</span>
              <p class="money-style">
                {{ this.valorMinimoFranquiaEmReal }}
              </p>
            </div>
            <div class="lg:w-1/4 w-1/2 mb-2 text-center hidden">
              <span class="vs-input--label">Franquia em %</span>
              <p class="money-style">{{ this.cotaParticipacaoPorcentagem }}%</p>
            </div>
            <div class="lg:w-1/4 w-1/2 mb-2 text-center hidden">
              <span class="vs-input--label">Valor Calculado da Franquia</span>
              <p class="money-style">{{ this.valorFranquiaEmReal }}</p>
            </div>
          </div>
          <div class="vx-row flex items-center mb-4 gap-3 lg:gap-0">
            <div class="vx-col lg:w-1/6 w-full flex justify-center hidden">
              <vs-button @click="calcularValorFranquia()">
                Calcular Valor da Franquia
              </vs-button>
            </div>
            <div class="vx-col lg:w-1/6 w-full flex justify-center">
              <vs-button color="warning" @click="desconsiderarValorFranquia()">
                Desconsiderar Franquia
              </vs-button>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
              <label class="vs-input--label">Valor da Franquia Aplicado</label>
              <money
                class="w-full vs-inputx vs-input--input money-style"
                v-model="formCustoEvento.cotaParticipacao"
                name="Valor da Franquia"
                v-bind="money"
              />
            </div>
            <div class="vx-col lg:w-1/3 w-full">
              <vs-alert
                v-if="valorMinimoParticipacaoAplicado"
                color="warning"
                class="text-center flex items-center justify-center"
              >
                O valor da franquia é menor que o valor mínimo da franquia.
                valor mínimo da franquia aplicado.
              </vs-alert>
              <vs-alert
                v-if="desconsiderarFranquia"
                color="warning"
                class="text-center flex items-center justify-center"
              >
                Franquia desconsiderada. Valor da franquia aplicada zerado.
              </vs-alert>
              <vs-alert
                v-if="valorFranquiaInvalido"
                color="danger"
                class="text-center flex items-center justify-center"
              >
                O valor da franquia aplicada não pode ser menor que o valor
                mínimo da franquia.
              </vs-alert>
            </div>
          </div>
        </div>
        <div class="m-3 mb-5">
          <h5 class="mb-2">Valores</h5>
          <div class="vx-row">
            <div class="vx-col lg:w-1/3 w-full mb-2">
              <label class="vs-input--label">Valor Bruto de Reparo</label>
              <money
                class="w-full vs-inputx vs-input--input money-style"
                v-model="formCustoEvento.valorReparo"
                name="Previsão de Valor de Reparo"
                v-bind="money"
              />
            </div>
            <div class="vx-col lg:w-1/3 w-full mb-2">
              <label class="vs-input--label">Valor das Peças Fornecidas</label>
              <money
                class="w-full vs-inputx vs-input--input money-style"
                v-model="formCustoEvento.valorPecasFornecidas"
                name="Valor das Peças Fornecidas"
                v-bind="money"
              />
            </div>
            <div class="vx-col lg:w-1/3 w-full mb-2">
              <label class="vs-input--label"
                >Custo Líquido para a Oficina</label
              >
              <money
                class="w-full vs-inputx vs-input--input money-style"
                v-model="formCustoEvento.custoReparo"
                name="Custo Líquido"
                v-bind="money"
                disabled
              />
              <small>Valor Reparo - (Valor Franquia + Valor Peças)</small>
            </div>
          </div>
        </div>
        <div class="m-3 mb-5">
          <h5 class="mb-2">Depreciação</h5>
          <div class="vx-row gap-3 lg:gap-0">
            <div class="vx-col lg:w-1/4 w-full mb-2">
              <label class="vs-input--label">Impostos + Taxas</label>
              <money
                class="w-full vs-inputx vs-input--input money-style"
                v-model="formCustoEvento.impostosTaxas"
                name="Impostos + Taxas"
                v-bind="money"
              />
            </div>
            <div class="vx-col lg:w-1/4 w-full mb-2">
              <label class="vs-input--label">Quitação/Financiamento</label>
              <money
                class="w-full vs-inputx vs-input--input money-style"
                v-model="formCustoEvento.quitacaoFinanciamento"
                name="Quitação/Financiamento"
                v-bind="money"
              />
            </div>
            <div
              class="vx-col lg:w-1/4 w-1/2 flex justify-center flex-col items-center"
            >
              <span>Sofre Depreciação</span>
              <vs-switch
                color="success"
                v-model="formCustoEvento.sofreDepreciacao"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>
          <div v-if="formCustoEvento.sofreDepreciacao">
            <div class="vx-row mb-2">
              <div class="vx-col lg:w-1/2 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Motivo da Depreciação"
                  placeholder=""
                  v-model="formCustoEvento.depreciacaoMotivo"
                  name="Depreciação Motivo"
                />
              </div>
              <div class="vx-col lg:w-1/4 w-full mb-2">
                <label class="vs-input--label">Depreciação %</label>
                <money
                  class="w-full vs-inputx vs-input--input money-style"
                  v-model="formCustoEvento.depreciacaoPorCento"
                  name="Depreciação %"
                  v-bind="porCento"
                />
              </div>
              <div class="vx-col lg:w-1/4 w-full mb-2">
                <label class="vs-input--label">Valor Depreciado</label>
                <money
                  class="w-full vs-inputx vs-input--input money-style"
                  v-model="formCustoEvento.depreciacaoValor"
                  name="Depreciação Valor"
                  v-bind="money"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
        <div class="m-3 mb-5">
          <h5 class="mb-2">Outras Informações</h5>
          <div class="vx-col lg:w-1/2 w-full my-3">
            <label class="vs-input--label">Empresa Pagante</label>
            <v-select
              :options="companiesList"
              label="label"
              :reduce="(item) => item.id"
              v-model="formCustoEvento.referenceCompanyPayment"
              placeholder="Selecione uma empresa"
              class="w-full"
              :clearable="false"
              :searchable="true"
              :close-on-select="true"
              :value="formCustoEvento.referenceCompanyPayment"
            ></v-select>
          </div>
        </div>
        <hr class="mb-6" style="box-shadow: 0px 4px 4px 0px #00000040" />
        <div class="vx-row flex justify-center gap-5 lg:gap-0">
          <div
            class="vx-col w-1/2"
            v-if="!this.formCustoEvento.valorReparo"
          ></div>
          <div class="vx-col lg:w-1/2 w-full" v-else>
            <div class="vx-row text-base">
              <div class="vx-col w-1/2 text-right">
                <p>Valor Bruto de Reparo:</p>
                <p>Valor da Franquia</p>
                <p v-if="formCustoEvento.impostosTaxas">Impostos + Taxas</p>
                <p v-if="formCustoEvento.valorPecasFornecidas">
                  Valor das Peças Fornecidas
                </p>
                <p v-if="formCustoEvento.aplicaCalculoBoletosNaoBaixados">
                  Valor Boletos em Aberto
                </p>
                <p v-if="formCustoEvento.sofreDepreciacao">Valor Depreciação</p>
                <p>Valor Total do Evento</p>
              </div>
              <div class="vx-col w-1/2">
                <p class="text-green">
                  &nbsp;&nbsp;{{ this.valorReparoEmReal }}
                </p>
                <p class="text-red">- {{ this.valorFranquiaAplicadoEmReal }}</p>
                <p v-if="formCustoEvento.impostosTaxas" class="text-red">
                  - {{ this.valorImpostosTaxasEmReal }}
                </p>
                <p v-if="formCustoEvento.valorPecasFornecidas" class="text-red">
                  - {{ this.valorPecasFornecidasEmReal }}
                </p>
                <p v-if="formCustoEvento.sofreDepreciacao" class="text-red">
                  - {{ this.valorDepreciacaoEmReal }}
                </p>
                <p
                  :class="
                    this.formCustoEvento.valorTotalEvento > 0
                      ? 'font-bold'
                      : 'font-bold text-red'
                  "
                >
                  {{ this.valorTotalEventoEmReal || 0 }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="vx-col lg:w-1/2 w-full text-xl text-center flex flex-col justify-center"
          >
            <p>Valor Final Custo Empresa:</p>
            <small class="text-sm"
              >Valor Bruto Reparo - Valor Franquia Aplicado</small
            >
            <p
              v-if="
                formCustoEvento.valorTotalEvento > 0 ||
                formCustoEvento.valorReparo
              "
              class="font-bold"
            >
              {{ this.valorFinalCustoEmpresaEmReal }}
            </p>
            <small class="font-bold" v-else-if="!formCustoEvento.valorReparo"
              >Preencha o valor bruto para calcular.</small
            >
            <small
              class="font-bold"
              v-else-if="formCustoEvento.valorTotalEvento < 0"
              >O valor final não pode ser menor que zero.</small
            >
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { Money } from 'v-money';
import functions from '../../../../../utils/functions';
import service from '../../../../../services';
import {
  companies,
  companiesDev,
} from '../../Eventos/tabs/ReparoVeiculo/utils/';
import vSelect from 'vue-select';
export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      const objCustoEvento = this.treatObjectFormDataToSetTheDefaultValue(
        value.custoEvento,
      );

      if (!objCustoEvento) {
        this.showComponent = false;
        return;
      }

      this.placaChassiVeiculo = value.dadosVeiculoTerceiro.placa
        ? value.dadosVeiculoTerceiro.placa
        : value.dadosVeiculoTerceiro.chassi;

      this.formCustoEvento = Object.assign(
        this.formCustoEvento,
        objCustoEvento,
      );

      this.anoFabricacao = value.dadosVeiculoTerceiro.anoFabricacao;

      this.dadosVeiculo = {
        codigo_fipe: value.dadosVeiculoTerceiro.codigoFipe,
        codigoTipoVeiculo: value.dadosVeiculoTerceiro.codTipoVeiculo,
        anoModelo: value.dadosVeiculoTerceiro.anoModelo,
        codigoMarca: value.dadosVeiculoTerceiro.veiculoMarca,
        codigoModelo: value.dadosVeiculoTerceiro.veiculoModelo,
        combustivel: value.dadosVeiculoTerceiro.combustivel,
      };

      this.valorParticipacaoMinimo =
        objCustoEvento.valorParticipacaoMinimo || 0;
      this.cotaParticipacaoPorcentagem = objCustoEvento.cotaParticipacao || 0;

      this.valorFipeDataEvento =
        this.formData.cadastroTerceiro.valorFipeDataEvento;
      this.dataEvento = this.formData.cadastroTerceiro.dataEvento;

      this.valorCotaParticipacaoBase =
        this.valorFipeDataEvento * (this.cotaParticipacaoPorcentagem / 100);

      this.horaDataUltimaAtualizacaoCalculoBoleto =
        this.formData.custoEvento.updatedAtCalculoBoletos;

      if (this.formData.cadastroTerceiro.dataReferenciaValorFipe) {
        const [ano, mes, dia] =
          this.formData.cadastroTerceiro.dataReferenciaValorFipe
            .split('T')[0]
            .split('-');

        this.dataReferenciaValorFipe = `${dia}/${mes}/${ano}`;
        return;
      }
      this.dataReferenciaValorFipe = this.formData.cadastroTerceiro.dataEvento;

      if (value.dadosReparo.referenceCompanyPayment) {
        this.formCustoEvento.referenceCompanyPayment =
          value.dadosReparo.referenceCompanyPayment;
      }
    },

    'formCustoEvento.valorReparo': function () {
      this.calculaValorFinalEvento();
    },

    'formCustoEvento.depreciacaoPorCento'(porcentagemDepreciacao) {
      this.formCustoEvento.depreciacaoValor =
        (this.valorFipeDataEvento / 100) * porcentagemDepreciacao;

      this.calculaValorFinalEvento();
    },

    'formCustoEvento.sofreDepreciacao'() {
      this.calculaValorFinalEvento();
    },

    'formCustoEvento.impostosTaxas'() {
      this.calculaValorFinalEvento();
    },

    'formCustoEvento.valorPecasFornecidas'() {
      const { valorReparo, cotaParticipacao, valorPecasFornecidas } =
        this.formCustoEvento;

      const custoLiquido =
        valorReparo - (cotaParticipacao + valorPecasFornecidas);

      this.formCustoEvento.custoReparo = custoLiquido;
      this.calculaValorFinalEvento();
    },

    'formCustoEvento.cotaParticipacao'() {
      this.validaValorFranquiaPermitido(
        this.formCustoEvento.cotaParticipacao,
        this.valorParticipacaoMinimo,
      );

      const { valorReparo, cotaParticipacao, valorPecasFornecidas } =
        this.formCustoEvento;

      const custoLiquido =
        valorReparo - (cotaParticipacao + valorPecasFornecidas);

      this.formCustoEvento.custoReparo = custoLiquido;
      this.calculaValorFinalEvento();
    },
  },
  computed: {
    valorFipeDataEventoEmReal() {
      return functions.formataReal(this.valorFipeDataEvento || 0);
    },
    valorMinimoFranquiaEmReal() {
      return functions.formataReal(this.valorParticipacaoMinimo || 0);
    },
    valorReparoEmReal() {
      return functions.formataReal(this.formCustoEvento.valorReparo || 0);
    },
    valorFranquiaEmReal() {
      return functions.formataReal(this.valorCotaParticipacaoBase);
    },
    valorFranquiaAplicadoEmReal() {
      return functions.formataReal(this.formCustoEvento.cotaParticipacao || 0);
    },
    valorBoletosAbertosAtualEmReal() {
      return functions.formataReal(this.totalValorBoletosNaoBaixadosAtual);
    },
    valorBoletosAbertosAnterioresEmReal() {
      return functions.formataReal(
        this.totalValorBoletosNaoBaixadosAnterior || 0,
      );
    },
    valorTotalEventoEmReal() {
      return functions.formataReal(this.formCustoEvento.valorTotalEvento || 0);
    },
    valorImpostosTaxasEmReal() {
      return functions.formataReal(this.formCustoEvento.impostosTaxas || 0);
    },
    valorPecasFornecidasEmReal() {
      return functions.formataReal(
        this.formCustoEvento.valorPecasFornecidas || 0,
      );
    },
    valorDepreciacaoEmReal() {
      return functions.formataReal(this.formCustoEvento.depreciacaoValor || 0);
    },

    valorFinalCustoEmpresaEmReal() {
      const valorFinalCustoEmpresa =
        this.formCustoEvento.valorReparo -
        this.formCustoEvento.cotaParticipacao;
      return functions.formataReal(valorFinalCustoEmpresa);
    },
    valorBoletosNaoBaixadosEmReal() {
      return functions.formataReal(
        this.formCustoEvento.valorBoletosNaoBaixados || 0,
      );
    },
    companiesList() {
      const nodeEnv = process.env.VUE_APP_NODE_ENV || 'development';
      const isDev = nodeEnv.includes('development') || nodeEnv.includes('qa');
      const companiesList = isDev ? companiesDev : companies;
      return companiesList.map((company) => ({
        id: company.companyId,
        label: `${company.companyId} - ${company.label} - ${company.cnpj}`,
        cnpj: company.cnpj,
      }));
    },
  },
  components: {
    Money,
    vSelect,
  },
  data() {
    return {
      showComponent: true,
      listCombustiveis: [],
      formCustoEvento: {
        valorReparo: 0,
        valorFranquia: 0,
        impostosTaxas: 0,
        quitacaoFinanciamento: 0,
        sofreDepreciacao: false,
        cotaParticipacao: 0,
        depreciacaoMotivo: null,
        depreciacaoPorCento: 0,
        depreciacaoValor: 0,
        custoReparo: 0,
        valorTotalEvento: 0,
        valorBoletosNaoBaixados: 0,
        qtdBoletosBaixados: 0,
        referenceCompanyPayment: null,
      },
      valorParticipacaoMinimo: 0,
      valorCotaParticipacaoBase: 0,
      cotaParticipacaoPorcentagem: 0,
      valorFipeDataEvento: 0,
      porCento: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 0,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      dadosVeiculo: {},
      idProspect: null,
      placaChassiVeiculo: null,
      qtdBoletosBaixadosAtual: 0,
      qtdBoletosBaixadosAnterior: 0,
      totalValorBoletosNaoBaixadosAtual: 0,
      totalValorBoletosNaoBaixadosAnterior: 0,
      horaDataUltimaAtualizacaoCalculoBoleto: null,
      boletosMensalidade: [],
      desconsiderarFranquia: false,
      valorMinimoParticipacaoAplicado: false,
      valorFranquiaInvalido: false,
      tipoCalculoBoletoDestacado: 'anterior',
      aplicarCalculoBoletosAtualizado: false,
      dataEvento: null,
      dataReferenciaValorFipe: null,
    };
  },
  methods: {
    treatObjectFormDataToSetTheDefaultValue(formDataEventPrice) {
      const listInfoToNormalize = {
        cotaParticipacao: 0,
        valorReparo: 0,
        valorPecasFornecidas: 0,
        custoReparo: 0,
        impostosTaxas: 0,
        quitacaoFinanciamento: 0,
        depreciacaoPorCento: 0,
        depreciacaoValor: 0,
      };
      const normalizedData =
        functions.handleObjFormDataReplaceNullToDefaultValue(
          formDataEventPrice,
          listInfoToNormalize,
        );
      return normalizedData;
    },
    calcularValorFranquia() {
      this.desconsiderarFranquia = false;
      this.valorFranquiaInvalido = false;

      this.valorMinimoParticipacaoAplicado =
        this.valorParticipacaoMinimo > this.valorCotaParticipacaoBase;

      this.formCustoEvento.cotaParticipacao = this
        .valorMinimoParticipacaoAplicado
        ? this.valorParticipacaoMinimo
        : this.valorCotaParticipacaoBase;

      this.formCustoEvento.valorTotalEvento =
        this.formCustoEvento.valorReparo -
        this.formCustoEvento.cotaParticipacao;

      this.calculaValorFinalEvento();
    },

    desconsiderarValorFranquia() {
      this.desconsiderarFranquia = true;
      this.valorMinimoParticipacaoAplicado = false;
      this.valorFranquiaInvalido = false;
      this.formCustoEvento.cotaParticipacao = 0;
      this.calculaValorFinalEvento();
    },

    calculaValorFinalEvento() {
      const valorReparo = this.formCustoEvento.valorReparo || 0;
      const valorFranquia = this.formCustoEvento.cotaParticipacao || 0;
      const valorImpostosTaxas = this.formCustoEvento.impostosTaxas || 0;
      const valorPecasFornecidas =
        this.formCustoEvento.valorPecasFornecidas || 0;
      const valorBoletosNaoBaixados =
        this.formCustoEvento.valorBoletosNaoBaixados || 0;
      const valorDepreciacao = this.formCustoEvento.depreciacaoValor || 0;
      const { sofreDepreciacao } = this.formCustoEvento;

      const valorFinal =
        valorReparo -
        valorFranquia -
        valorImpostosTaxas -
        valorPecasFornecidas -
        valorBoletosNaoBaixados -
        (sofreDepreciacao ? valorDepreciacao : 0);

      this.formCustoEvento.valorTotalEvento = valorFinal;

      this.$emit('updateCustoEvento', this.formCustoEvento);
    },

    validaValorFranquiaPermitido(valorInput, valorMinimo) {
      this.desconsiderarFranquia = false;
      this.valorMinimoParticipacaoAplicado = false;
      this.valorFranquiaInvalido = valorInput !== 0 && valorInput < valorMinimo;
    },

    calculaBoletosNaoBaixados(boolean) {
      if (!boolean) {
        this.formCustoEvento.updatedAtCalculoBoletos = null;
        this.formCustoEvento.valorBoletosNaoBaixados = null;
        this.formCustoEvento.qtdBoletosBaixados = null;
        this.calculaValorFinalEvento();
        return;
      }

      if (
        !this.totalValorBoletosNaoBaixadosAnterior ||
        this.aplicarCalculoBoletosAtualizado
      ) {
        this.tipoCalculoBoletoDestacado = this.aplicarCalculoBoletosAtualizado
          ? 'atual'
          : 'anterior';
        this.formCustoEvento.updatedAtCalculoBoletos = new Date();
        this.formCustoEvento.valorBoletosNaoBaixados =
          this.totalValorBoletosNaoBaixadosAtual;
        this.formCustoEvento.qtdBoletosBaixados = this.qtdBoletosBaixadosAtual;
        this.calculaValorFinalEvento();
        return;
      }

      this.tipoCalculoBoletoDestacado = 'anterior';
      this.formCustoEvento.updatedAtCalculoBoletos =
        this.horaDataUltimaAtualizacaoCalculoBoleto;
      this.formCustoEvento.valorBoletosNaoBaixados =
        this.totalValorBoletosNaoBaixadosAnterior;
      this.formCustoEvento.qtdBoletosBaixados = this.qtdBoletosBaixadosAnterior;
      this.calculaValorFinalEvento();
    },
    async getListCombustivel(idCombustivel) {
      try {
        const res = await service.post('Cotacao', 'listarCoresECombustivel', {
          idEmpresa: null,
        });
        const listCombustiveis = [];
        res.data.combustiveis.forEach((element) => {
          listCombustiveis.push({
            id: element.idCombustivel,
            label: element.descricao,
          });
        });

        const combustivel = listCombustiveis.find(
          (comb) => comb.id === idCombustivel,
        ).label;

        return combustivel;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error || 'Erro ao buscar combustíveis',
          color: 'danger',
        });
      }
    },
    async calcularFipeMesEvento() {
      try {
        this.$vs.loading();
        const { dataEvento } = this.formData.cadastroTerceiro;
        const { anoModelo, idCombustivel, codigoFipe } =
          this.formData.dadosVeiculoTerceiro;

        const combustivel = await this.getListCombustivel(idCombustivel);

        const objSend = {
          codigoFipe,
          combustivel,
          anoModelo,
          dataBusca: dataEvento,
          idEvento: this.formData.idEvento,
        };

        if (!codigoFipe || !anoModelo || !combustivel || !dataEvento) {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados do veículo incompletos, favor preencher no campo Dados do Veículo do Terceiro',
            color: 'danger',
          });
          return;
        }

        const result = await service.post(
          'eventos2',
          'calcular-valor-historico-fipe',
          objSend,
        );

        const { data } = result;
        this.valorFipeDataEvento = data.valorFipe;

        this.formCustoEvento.depreciacaoPorCento = 0;
        this.formCustoEvento.depreciacaoMotivo = null;
        this.formCustoEvento.depreciacaoValor = 0;

        // eslint-disable-next-line vue/no-mutating-props
        this.formData.cadastroTerceiro.valorFipeDataEvento = data.valorFipe;
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.cadastroTerceiro.dataReferenciaValorFipe = dataEvento;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error || 'Erro ao buscar histórico do valor FIPE',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    if (!this.formData.custoEvento) {
      console.error('ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.custoEvento = this.formCustoEvento.valorTotalEvento;
  },
};
</script>

<style scoped>
.money-style {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}

.text-green {
  color: rgb(21, 128, 61);
}

.text-red {
  color: rgb(153, 27, 27);
}
</style>
